"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboxInvoice = void 0;
class InboxInvoice {
    constructor(data) {
        if (data) {
            this.deserialize(data);
        }
    }
    deserialize(input) {
        Object.assign(this, Object.assign(Object.assign({}, input), { id: input.id || input._id }));
        return this;
    }
}
exports.InboxInvoice = InboxInvoice;
